module.exports = __webpack_public_path__ + "img/product_19.cbf49f9.webp";